import { useWebWidgetStore } from '../store/store.ts'

export const useIsEmbedMode = (): boolean => useWebWidgetStore(state => !!state.embedFeature)
